import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { editQuizTemplateRequested } from 'features/quizzes/actions';

export function* editQuizTemplateSaga(action: ReturnType<typeof editQuizTemplateRequested>) {
  yield call(SignalingSocket.send, { event: 'editQuizTemplate', data: action.payload });
}
